export default "__VITE_ASSET__Bb6ahl89__"